import React, { useContext } from 'react';
import { Link } from 'gatsby';
import { useLocation } from '@gatsbyjs/reach-router';
import './Dropdown.scss';
import Avatar from '../Avatar';
import UserContext from '../../context/userContext';

function Dropdown() {
  const location = useLocation();
  const isCreateProfile = location?.pathname === '/user/create-profile' || location?.pathname === '/user/create-profile/';
  const { user } = useContext(UserContext);

  return (
    <Link to={`/user/profile?id=${user?._id}`} className="dropdown icon">
      <Avatar sm url={isCreateProfile ? '' : user?.media?.profile_photo} />
      <span>{isCreateProfile ? '' : (user?.name ?? '')}</span>
    </Link>
  );
}

export default Dropdown;
